var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUpgrades = function SvgUpgrades(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 18.13,
    y1: 170.17,
    x2: 180.39,
    y2: 31.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 17.91,
    y1: 169.91,
    x2: 180.16,
    y2: 30.83,
    xlinkHref: "#b"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M100,145.69c4.31,0,7.81-3.5,7.81-7.81v-56.55l15.79,16.19c1.53,1.57,3.56,2.36,5.59,2.36s3.93-.74,5.45-2.22c3.09-3.01,3.15-7.96.14-11.05l-29.19-29.93c-1.47-1.51-3.49-2.36-5.59-2.36s-4.12.85-5.59,2.36l-29.19,29.93c-3.01,3.09-2.95,8.04.14,11.05,3.09,3.01,8.04,2.95,11.05-.14l15.79-16.19v56.55c0,4.31,3.5,7.81,7.81,7.81Z",
    style: {
      fill: "url(#b)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.71,29.29C151.82,10.4,126.71,0,100,0S48.18,10.4,29.29,29.29C10.4,48.18,0,73.29,0,100s10.4,51.82,29.29,70.71c18.89,18.89,44,29.29,70.71,29.29,19.76,0,38.88-5.76,55.27-16.65,3.59-2.39,4.57-7.24,2.18-10.83-2.39-3.59-7.24-4.57-10.83-2.18-13.83,9.19-29.95,14.04-46.63,14.04-46.52,0-84.38-37.85-84.38-84.37S53.48,15.62,100,15.62s84.37,37.85,84.37,84.38c0,15.87-4.43,31.32-12.8,44.7-2.29,3.66-1.18,8.48,2.48,10.77,3.66,2.29,8.48,1.18,10.77-2.48,9.93-15.87,15.18-34.19,15.18-52.99,0-26.71-10.4-51.82-29.29-70.71Z",
    style: {
      fill: "url(#c)",
      strokeWidth: 0
    }
  }));
};
export default SvgUpgrades;